import { useState, type JSX } from 'react';
import { Button } from '../ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover';
import { Popover as PopoverPrimitive } from 'radix-ui';
import {
  BOOLEAN_FILTER,
  DATE_FILTER,
  NUMBER_FILTER,
  RELATION_FILTER,
  SELECT_FILTER,
  STRING_FILTER,
  TAG_FILTER,
  getReadableOperator,
  type Filter,
  type FilterValue,
} from './constants';
import FilterValueInput from './filter-value-input';
import RelationModal from './relation-modal';
import { cn } from '@/lib/cn';

export default function CurrentCreatingFilter({
  currentCreating,
  onDone,
  TableFilters,
}: {
  currentCreating: Filter;
  onDone: (value: FilterValue) => void;
  TableFilters: ({
    clientState,
    filters,
    tableId,
  }: {
    clientState?: boolean;
    filters: Filter[];
    tableId: string;
  }) => JSX.Element;
}) {
  const [currentCreatingValue, setCurrentCreatingValue] =
    useState<FilterValue>(null);
  return (
    <>
      {(currentCreating.kind === RELATION_FILTER ||
        currentCreating.kind === TAG_FILTER) && (
        <RelationModal
          TableFilters={TableFilters}
          filter={currentCreating}
          initialValue={(currentCreatingValue as unknown as string[]) ?? []}
          onDone={(val) => onDone(val)}
        />
      )}

      <Popover
        modal
        open={true}
        onOpenChange={(open) => {
          if (open) return;
          onDone(currentCreatingValue);
        }}
      >
        <PopoverPrimitive.PopoverAnchor>
          <div className='flex flex-nowrap items-center'>
            <Button
              className='cursor-default rounded-l-full border py-1.5 pr-2 pl-2.5 text-xs font-medium hover:bg-transparent'
              variant='ghost'
            >
              {currentCreating.title}
            </Button>
            <Button
              className='rounded-none border-y border-r border-r-border px-2 py-1.5 text-xs text-muted-foreground'
              variant='ghost'
            >
              {getReadableOperator(
                currentCreating.defaultOperator,
                currentCreating.kind
              )}
            </Button>

            {currentCreating.kind === RELATION_FILTER ||
            currentCreating.kind === TAG_FILTER ? null : (
              <>
                <PopoverTrigger asChild>
                  <Button
                    variant='ghost'
                    className='rounded-none rounded-r-full border-y border-r border-r-border py-1.5 pr-2.5 pl-2 text-xs font-medium'
                  >
                    <div className='max-w-44 truncate'>
                      {currentCreating.kind === SELECT_FILTER &&
                      (Array.isArray(currentCreatingValue) ||
                        currentCreatingValue == null)
                        ? currentCreatingValue &&
                          currentCreatingValue?.length > 0
                          ? (currentCreatingValue || [])
                              .map(
                                (f) =>
                                  currentCreating.choices?.find((c) => c.v == f)
                                    ?.d
                              )
                              .join(', ')
                          : '...'
                        : currentCreating.kind === BOOLEAN_FILTER
                          ? currentCreatingValue === false
                            ? 'Falskt'
                            : 'Sant'
                          : currentCreating.kind === DATE_FILTER
                            ? '... dagarna'
                            : currentCreatingValue || '...'}
                    </div>
                  </Button>
                </PopoverTrigger>
                <PopoverContent
                  align='start'
                  className={cn(
                    'p-0',
                    (currentCreating.kind === STRING_FILTER ||
                      currentCreating.kind === NUMBER_FILTER ||
                      currentCreating.kind === DATE_FILTER) &&
                      'p-2'
                  )}
                >
                  <FilterValueInput
                    onDone={() => onDone(currentCreatingValue)}
                    filter={currentCreating}
                    operator={currentCreating.defaultOperator}
                    value={currentCreatingValue}
                    setValue={(val) => setCurrentCreatingValue(val)}
                  />
                </PopoverContent>
              </>
            )}
          </div>
        </PopoverPrimitive.PopoverAnchor>
      </Popover>
    </>
  );
}
